
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
//import DatePicker from "react-datepicker";
import banner from '../pics/banner.PNG';
import About from '../About/About';
import Select from 'react-select';
import { FaWhatsapp } from 'react-icons/fa';
import { ArrowLeft } from 'react-bootstrap-icons';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import axios from 'axios';
import { getAllCustomerRegistrations, getAllCustomerOrders } from '../Utils/Utils';
import { LayoutDashboard, Menu, User } from 'lucide-react';
//import { redirect } from 'next/dist/server/api-utils';
class UserProfile extends React.Component {
    constructor(props) {
        super(props);
        this.handleAboutOpen = React.createRef();
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            userid: "",
            address: '',
            area: '',
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            token: "",
            role: "",
            city: "",
            gender: "",
            customerslist: [],
            selectedCustomer: null,
            allcustomers: [],
            modifiedby: "",
            userstatus: "",
            selectedUserStatus: "",
            registrationdate: "",
            oldUserStatus: "",
            oldUserRole: "",
            oldUserPhoneNumber: "",
            oldUserAddress: "",
            oldUserArea: "",
            isEditing: null,
            userOrderCount: 0,
            userOrders: [],
            allcustomerorders: [],
            lastorderdate:'',
            inputRef: React.createRef(null)
        }
    }

    str_lastorderdate = '';
    strToday = new Date()

    componentDidMount = async () => {
        if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
            this.setState({ shouldRedirect: true });
        }
        else {
            if (this.props.location.state.role !== "Admin") {
                // this.setState({oldUserStatus: this.props.location.state.userstatus, 
                //     oldUserRole: this.props.location.state.role, oldUserPhoneNumber: this.props.location.state.phonenumber, 
                //     oldUserArea: this.props.location.state.area, oldUserAddress: this.props.location.state.address});
                document.getElementById("admincreateorder").style.display = "none";
            }
            const allcustomers = await getAllCustomerRegistrations();
            const allcustomerorders = await getAllCustomerOrders();
            let userOrders = [];
            allcustomerorders.forEach(order => {
                if (order.emailaddress === this.props.location.state.emailaddress) {
                    userOrders.push(order);
                }
            });
             
             this.str_lastorderdate = userOrders[0].modified.slice(0,10);
           //  console.log("User orders: ", this.str_lastorderdate);
            this.setState({ userOrderCount: userOrders.length, userOrders: userOrders, lastorderdate: userOrders[0].modified.slice(0,10)});
            // console.log("All customers orders: ", allcustomerorders);
            //   console.log("User orders: ", userOrders);
            let customersOptions = [];
            allcustomers.forEach(customer => {
                customersOptions.push({ label: customer.fullname, value: customer.id });
            });
            //  console.log("userstatus:", this.props.location.state.userstatus);
            const user = allcustomers.find(user => user.emailaddress === this.props.location.state.emailaddress);
            if (user) {
                this.setState({
                    role: user.role, address: user.address, area: user.area, city: user.city, userstatus: user.status,
                    userid: user.id, registrationdate: user.modified
                });
            }
            this.setState({
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, modifiedby: this.props.location.state.fullname,
                phonenumber: this.props.location.state.phonenumber, gender: this.props.location.state.gender, customerslist: customersOptions,
                allcustomers: allcustomers, selectedUserStatus: this.props.location.state.userstatus, allcustomerorders: allcustomerorders
            })
        }
        if (this.props.location.state.role === "User") {
            for (let i = 0; i < this.adminUserInputs.length; i++) {
                document.getElementById(this.adminUserInputs[i]).style.display = "none";
            }
        }
    }

    userRoles = [{ label: "Admin", value: "Admin" }, { label: "User", value: "User" }];

    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    goBackToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/home', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, phonenumber: this.props.location.state.phonenumber, gender: this.props.location.state.gender,
                role: this.props.location.state.role, address: this.props.location.state.address, city: this.props.location.state.city, area: this.props.location.state.area,
                userid: this.props.location.state.userid, userstatus: this.state.userstatus, registrationdate: this.state.registrationdate
            }
        });
    }


    todayISO = new Date().toISOString().slice(0, 10);
       
    handleGenderChange = (event) => {
        this.setState({
            gender: event.target.value
        });
        //console.log(event.target.value);
    }
    setPhoneNumber = (e) => {
        const limitedPhone = e.target.value;
        if (limitedPhone.length > 10) {
            alert("Phone number cannot exceed 10 digits");
        }
        this.setState({ phonenumber: limitedPhone });
    }
    setAddress = (e) => {
        this.setState({ address: e.target.value, oldUserAddress: this.props.location.state.address });
    }


    userStatuses = [{ label: "Active", value: "Active" }, { label: "Inactive", value: "Inactive" }];

    serviceAreas = [{ label: "Blouberg", value: "Blouberg" },
    { label: "Maitland", value: "Maitland" },
    { label: "Milnerton", value: "Milnerton" },
    { label: "Parklands", value: "Parklands" },
    { label: "Sunningdale", value: "Sunningdale" },
    { label: "Other", value: "Other" }
    ];

    setStatusChange = (e) => {

        this.setState({ userstatus: e.value });
    }

    updateUserProfile = async () => {
        // Implement order creation logic here, such as sending data to the backend API
        let config = {
            headers: { 'Content-Type': 'application/json' },
            params: {
                userid: this.state.userid,
                fullname: (this.state.fullname).trimEnd(),
                emailaddress: this.state.emailaddress,
                phonenumber: this.state.phonenumber,
                address: this.state.address,
                area: this.state.area,
                userstatus: this.state.userstatus,
                role: this.state.role,
                olduserstatus: this.state.oldUserStatus,
                olduserrole: this.state.oldUserRole,
                olduserphonenumber: this.state.oldUserPhoneNumber,
                olduseraddress: this.state.oldUserAddress,
                olduserarea: this.state.oldUserArea,
                modifiedby: (this.props.location.state.fullname).trimEnd(),
            }
        };
        //   console.log("Config params for update user profile: ", config.params);

        if ((this.state.oldUserStatus === "") && (this.state.oldUserPhoneNumber === "") && (this.state.oldUserAddress === "") && (this.state.oldUserArea === "") &&
            (this.state.oldUserRole === "")) {
            alert("Please make changes before saving the user profile.");
            return;
        }
        else {
            //   console.log(config.params);
            //  const url = "http://localhost/iwash-php/api/updateCustomerRecord.php";
            const url = "https://testmembership.bktsystems.com/api/UAT_updateCustomerRecord.php";
            // const url = "https://testmembership.bktsystems.com/api/updateCustomerRecord.php";
            const response = await axios.get(url, config);
            // console.log(response.data);
            if (response.data.includes("Success")) {
                document.getElementById("btnSubmit").style.display = "none";
                document.getElementById("successUpdate").style.display = "block";
                document.getElementById("errorUpdate").style.display = "none";
                this.setState({
                    oldUserStatus: '', oldUserRole: '', oldUserPhoneNumber: '', oldUserAddress: '', oldUserArea: '',

                });

                await this.componentDidMount();
            }
            else {
                document.getElementById("errorUpdate").style.display = "block";
            }
        }
    }

    adminUserInputs = ['adminuserstatus', 'adminuserrole', 'adminuserfullname', 'adminuseremail'];

    handleUserProfileForm = () => {
        // this.setState({ register: "", customeremail: "", customerphonenumber: "", customerfullname: "" });
        document.getElementById("btnSubmit").style.display = "none";
        this.props.navigate('/home', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role,
                address: this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city, userid: this.props.location.state.userid,
                gender: this.props.location.state.gender, userstatus: this.props.location.state.userstatus, registrationdate: this.props.location.state.registrationdate
            }
        });
    }

    setuserStatusChange = (e) => {
        this.setState({ userstatus: e.value, oldUserStatus: this.props.location.state.userstatus });
    }

    setuserRoleChange = (e) => {
        this.setState({ role: e.value, oldUserRole: this.props.location.state.role });
    }

    setUserArea = (e) => {
        this.setState({ area: e.value, oldUserArea: this.props.location.state.area });
    }

    setCustomerChange = (customerId) => {
        const selectedCustomer = this.state.allcustomers.find(customer => customer.id === customerId);
        let userOrders = [];
        this.state.allcustomerorders.forEach(order => {
            if (order.emailaddress === selectedCustomer.emailaddress) {
                userOrders.push(order);
            }
        });
        this.str_lastorderdate = userOrders[0].modified.slice(0,10);
        this.setState({
            selectedCustomer: selectedCustomer, phonenumber: selectedCustomer.phonenumber, address: selectedCustomer.address,
            area: selectedCustomer.area, city: selectedCustomer.city, fullname: selectedCustomer.fullname,
            emailaddress: selectedCustomer.emailaddress, userid: selectedCustomer.id, modifiedby: this.props.location.state.fullname,
            gender: selectedCustomer.gender, userstatus: selectedCustomer.status, role: selectedCustomer.role, registrationdate: selectedCustomer.modified,
            userOrderCount: userOrders.length, userOrders: userOrders

        });
    }

    customStyles = {
        control: (provided) => ({
            ...provided,
            height: '50px',
            borderBottom: "2px solid darkblue"
        })
    }

    handleDoubleClick = (field) => {
        const input = document.getElementById(`${field}`);
        // this.setState({ isEditing: field });
        if (input) {
            //  console.log("Double click event listener triggered for field:", field);
            input.removeAttribute('readonly');
            //      setTimeout(() => {
            //      input.focus();
            //  }, 0);
        };

    }

    handleBlur = () => {
        this.setState({ setIsEditing: false });
        // setIsEditing(false);
    };
    render() {
        if (this.state.shouldRedirect === true || this.props.location.state === null || this.props.location.state === undefined) {
            return <Navigate to="/" replace />;
        }

        return (
            <>
                <div style={{
                    height: "100%", margin: "0", padding: "0", paddingLeft: "10px", paddingRight: "10px",
                    fontFamily: "lora",
                }}>
                    <div className='mainDivHome' style={{
                        paddingTop: "5vh", border: '2px solid #f0eee4', borderRadius: "10px",
                        backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                    }}>
                        <div style={{
                            paddingTop: "10px", paddingBottom: "10px", textAlign: "center", color: "white", fontSize: "25px", fontWeight: "bold",
                            textShadow: "2px 2px 4px #000000"
                        }}>
                            <span style={{ fontStyle: "italic" }}><label>iWash Laundry Solutions </label></span><br />
                            <span style={{ fontStyle: "italic" }}><label>Logged in as {(this.state.fullname).split(" ")[0]} </label></span><br />
                            {/* <span style={{ fontStyle: "italic" }}><label>{this.state.date}</label></span> */}
                        </div>
                    </div>
                    <div style={{ border: "solid 1px lightgrey", borderRadius: "10px" }}>
                        <div style={{ textAlign: "center", paddingTop: "2vh", }}>
                            <span variant="primary" style={{
                                border: "none", paddingTop: "2vh", height: "60px", paddingBottom: "1vh",
                                display: "flex", width: "100%", borderRadius: "10px",
                            }} onClick={this.goBackToMenu}>
                                <label style={{
                                    textAlign: "center", fontStyle: "italic", color: "darkblue",
                                    fontWeight: "bold", textShadow: "1px 1px 2px grey", fontSize: "18px"
                                }}><ArrowLeft color="darkblue" size={40} /> </label>

                                <label style={{ flex: 1, fontStyle: "italic", color: "darkblue", fontWeight: "bold", textShadow: "1px 1px 2px grey", fontSize: "18px" }}>
                                    USER PROFILE</label></span>
                        </div>
                        <div id="admincreateorder" style={{ paddingTop: "15px", fontSize: "18px", color: "darkblue", paddingRight: "1px", paddingLeft: "1px" }}>
                            <FormGroup>
                                <Label for='selectcustomer' style={{ fontStyle: "italic" }}>Customer name</Label>
                                <Select
                                    styles={this.customStyles}
                                    options={this.state.customerslist || []}
                                    maxMenuHeight="100%"
                                    onChange={opt => this.setCustomerChange(opt.value)}
                                ></Select>
                            </FormGroup>
                        </div>
                        <div style={{ paddingTop: "10px", fontSize: "18px", color: "darkblue", paddingRight: "5px", paddingLeft: "1px" }}>
                            <div style={{
                                justifyContent: "space-between", width: "100%", paddingRight: "5px", paddingLeft: "15px",
                                border: "1px solid orangered", borderRadius: "10px", backgroundColor: "#fff4e8",
                            }}>
                                <FormGroup>
                                    <Label style={{ fontStyle: "italic", height: '15px', width: "100%", paddingTop: "10px", }}
                                        for="registrationdate">Registration date: {this.state.registrationdate}</Label>
                                </FormGroup>

                                <FormGroup style={{ width: "100%" }}>
                                    <Label style={{ fontStyle: "italic", height: '15px', width: "100%" }}
                                        for="ordercount">Total order count: {this.state.userOrderCount}</Label>
                                </FormGroup>
                                <FormGroup style={{ width: "100%" }}>
                                    <Label style={{ fontStyle: "italic", height: '15px', width: "100%" }}
                                        for="lastorder">Last order: {(this.state.userOrders[0] || {}).servicetype || 'N/A'}
                                    </Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                    Date: {this.state.userOrders[0] && this.state.userOrders[0].modified ? new Date(this.state.userOrders[0].modified).toLocaleDateString() : 'N/A'} 
                                 {' ** '} {Math.ceil((this.strToday - new Date(this.str_lastorderdate)) / (1000 * 60 * 60 * 24)) > 30 ? 
                                 <label style={{color:'red', fontStyle:'italic'}}>{'('}{Math.ceil((this.strToday - new Date(this.str_lastorderdate)) / (1000 * 60 * 60 * 24))}
                                 {' days ago)'}</label> :'('+ Math.ceil((this.strToday - new Date(this.str_lastorderdate)) / (1000 * 60 * 60 * 24))+' days ago)'}
                                    </Label>
                                </FormGroup>
                            </div>
                            <FormGroup style={{ paddingTop: "20px" }}>
                                <Label style={{ fontStyle: "italic", height: '30px', borderBottom: "1px solid darkblue", width: "100%", paddingtop: "20px" }}
                                    for='gender'>Gender: {this.state.gender}</Label>
                            </FormGroup>
                            <FormGroup>
                                <Label style={{ fontStyle: "italic", height: '30px', borderBottom: "1px solid darkblue", width: "100%" }}
                                    for='userstatus'>Status: {this.state.userstatus}</Label>
                            </FormGroup>
                            <FormGroup>
                                <Label style={{ fontStyle: "italic", height: '30px', borderBottom: "1px solid darkblue", width: "100%" }}
                                    for='userrole'>Role: {this.state.role}</Label>
                            </FormGroup>
                            <FormGroup>
                                <Label style={{ fontStyle: "italic", height: '30px', borderBottom: "1px solid darkblue", width: "100%" }}
                                    for='fullname'>Full name: {this.state.fullname}</Label>
                            </FormGroup>
                            <FormGroup>
                                <Label style={{ fontStyle: "italic", height: '30px', borderBottom: "1px solid darkblue", width: "100%" }}
                                    for='email'>Email: {this.state.emailaddress}</Label>
                            </FormGroup>
                            <FormGroup>
                                <Label style={{ fontStyle: "italic", height: '30px', borderBottom: "1px solid darkblue", width: "100%" }}
                                    for='city'>City: {this.state.city}</Label>
                            </FormGroup>
                            <FormGroup id="adminuserstatus">
                                <Label style={{ fontStyle: "italic" }} for='userstatus'>Status</Label>
                                <Select
                                    styles={(this.customStyles)}
                                    options={this.userStatuses || []}
                                    maxMenuHeight="100%"
                                    defaultInputValue={this.state.userstatus}
                                    // value={this.state.userstatus}
                                    onChange={this.setuserStatusChange}
                                    key={this.state.userstatus}
                                ></Select>
                            </FormGroup>
                            <FormGroup id="adminuserrole">
                                <Label style={{ fontStyle: "italic" }} for='userrole'>Role</Label>
                                <Select
                                    styles={(this.customStyles)}
                                    options={this.userRoles || []}
                                    maxMenuHeight="100%"
                                    defaultInputValue={this.state.role}
                                    // value={this.state.role}
                                    onChange={this.setuserRoleChange}
                                    key={this.state.role}
                                ></Select>
                            </FormGroup>
                            <FormGroup id="adminuserfullname">
                                <Label style={{ fontStyle: "italic" }} for='servicedate'>Full Name</Label>
                                <Input
                                    style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                    type='text'
                                    value={this.state.fullname}
                                    readOnly={true}
                                //  onChange={this.hadleFullNameChange}
                                />
                            </FormGroup>
                            <FormGroup id="adminuseremail">
                                <Label style={{ fontStyle: "italic" }} for='servicedate'>Email address</Label>
                                <Input
                                    style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                    type='text'
                                    value={this.state.emailaddress}
                                    readOnly={true}
                                //  onChange={this.hadleEmailChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label style={{ fontStyle: "italic" }} for='phonenumber'>Phone number</Label>
                                <Input
                                    style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                    type='number'
                                    id='phonenumber'
                                    data-field='phonenumber'
                                    // ref={this.state.inputRef}
                                    name='phonenumber'
                                    placeholder="07234567896"
                                    value={this.state.phonenumber}
                                    onChange={this.setPhoneNumber}
                                    readOnly={true}
                                    onDoubleClick={this.handleDoubleClick("phonenumber")}
                                    ref={(input) => {
                                        if (input && this.state.isEditing === 'phonenumber') {
                                            input.focus();
                                        }
                                    }}
                                    onBlur={this.handleDoubleClick(null)}
                                    min={10}
                                    max={10}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label style={{ fontStyle: "italic" }} for="areacity">Area</Label>
                                <Select
                                    styles={(this.customStyles)}
                                    options={this.serviceAreas || []}
                                    maxMenuHeight="100%"
                                    defaultInputValue={this.state.area}
                                    value={this.state.area}
                                    onChange={this.setUserArea}
                                    key={this.state.area}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label style={{ fontStyle: "italic" }} for="address">Address</Label>
                                <Input
                                    style={{ borderBottom: "2px solid darkblue" }}
                                    type="textarea"
                                    value={this.state.address}
                                    onChange={this.setAddress}
                                    rows="2"
                                />
                            </FormGroup>
                            <div id="successUpdate" style={{ display: "none", textAlign: "center", color: "green", fontWeight: "bold", paddingRight: "1px", paddingLeft: "1px" }}>
                                <FormGroup>
                                    <Label>Your profile has been updated successfully! &#128591;</Label>
                                </FormGroup>
                            </div>
                            <div id="errorUpdate" style={{ display: "none", textAlign: "center", color: "red", fontWeight: "bold", paddingRight: "1px", paddingLeft: "1px" }}>
                                <FormGroup>
                                    <Label>Sorry, there was an error updating your profile. Please try again &#128533;</Label>
                                </FormGroup>
                            </div>
                            <div id="btnSubmit" style={{ paddingTop: "10px", paddingRight: "1px", paddingLeft: "1px" }}>
                                <Button style={{ backgroundColor: "rgba(30, 104, 40, 1)", height: "60px", width: "100%", color: 'white', fontWeight: "bold" }}
                                    onClick={this.updateUserProfile}>Save Changes</Button>
                            </div>
                            <div id="btnCloseOrderForm" style={{ paddingTop: "20px", paddingBottom: "20px", paddingRight: "1px", paddingLeft: "1px" }}>
                                <Button style={{ width: "100%", fontWeight: "bold", height: "60px" }}
                                    onClick={this.handleUserProfileForm} color="danger">
                                    Close
                                </Button>
                            </div>
                        </div>
                        <div style={{
                            borderTop: "1px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666", height: "100%",
                            backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", paddingTop: "10px", paddingBottom: "10px"
                        }}>
                            <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                            <div>
                                <Button style={{
                                    backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                    fontWeight: "bold", textDecoration: "underline"
                                }}
                                    onClick={this.openAbout}>About Us
                                </Button>
                                | <a href="https://wa.me/+27796372245" rel="noopener noreferrer" target="_blank" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>

                            </div>
                        </div>
                        <div>
                            <About
                                ref={this.handleAboutOpen}
                                onAboutClose={this.onAboutClose}
                            />
                        </div>
                    </div>
                </div>
            </>)
    }
}
export default withNavigateHook(UserProfile);